import { mapGetters, mapMutations } from "vuex"
import { accessContent } from '@/student/api/Content.js'

export default {
  data() {
    return {
      width: '100%',
      playerReady: false,
      isPlaying: false,
      startTime: 0,
      millisecondsWatched: 0,
      updateTimeId: null,
      millisecondsDuration: 0,
      orientation: 'horizontal',
    }
  },
  computed: {
    ...mapGetters(['content','module','selectedCycle','accessing_content']),
    minimumPercentageWatch(){
      return this.selectedCycle.is_finished ? 0 : 60
    },
    secondsWatched(){
      return this.millisecondsWatched / 1000
    },
    secondsDuration(){
      return this.millisecondsDuration / 1000
    },
    minimumSecondsToFinish(){
      return this.secondsDuration * ( this.minimumPercentageWatch / 100 );
    },
    //Quantos segundos faltam para poder finalizar o vídeo com base na porcentagem minima
    minimumLeftSecondsToWatch(){
      return this.minimumSecondsToFinish - this.secondsWatched
    },
    percentageWatched() {
      if(this.content.finished_at){
        return 100
      }else{
        return this.millisecondsDuration === 0 ? 0: Math.trunc((this.secondsWatched * 100) / this.secondsDuration)
      }
    },
    nowInMilliseconds(){
      return Math.floor(Date.now() / 1000)
    },
    options(){
      return {
        muted: false,
        autoplay: false,
        pip: false,
      }
    },
    videoHeight(){
      return this.orientation == 'vertical' ?  540 : 540
    }
  },
  created(){
    
    this.millisecondsWatched = this.content.seconds_watched * 1000
    this.millisecondsDuration = this.content.seconds_duration * 1000

  },
  
  methods: {
        ...mapMutations(['SET_MODULE']),
        onFullscreenchange(op){
            setTimeout(()=>{
              if(op.fullscreen){
                this.$refs.player.play(), 500
              }else{
                this.onBlur()
              }
            })
      },
      onReady(player) {
        
        Promise.all([player.getVideoWidth(), player.getVideoHeight()]).then(dimensions => {
          const [width, height] = dimensions;
          if(width < height){
            this.orientation = 'vertical'
          }else{
            this.orientation = 'horizontal'
          }
          
        })

        if(!this.accessing_content) {
          accessContent(this.content.id)
        }
        
        this.createInterval()
        this.playerReady = true
        this.$refs.player.player.getDuration().then(seconds => {
          if(this.content.finished_at){
            this.millisecondsWatched = seconds * 1000
          }else{
            this.millisecondsDuration = seconds * 1000
          }
        })
      },
      mounted(){
       if(!this.accessing_content) {
          accessContent(this.content.id)
        }
      },
      play () {
        this.$refs.player.unmute()
        // this.$refs.emptyInput.focus()
        this.isPlaying = true
        this.startTime = Math.floor(Date.now() / 1000) - this.millisecondsWatched
        this.createInterval()
      },
      pause () {
        clearInterval(this.updateTimeId)
        this.isPlaying = false
        this.$refs.player.pause()
      },
      onEnded() {
        this.isPlaying = false
        clearInterval(this.updateTimeId)
      },
      onBlur(){
        this.pause()
      },
      onMute(){
        this.pause()
      },
      createInterval() {
        clearInterval(this.updateTimeId)
        let secondsCounter = 0
        this.updateTimeId = setInterval(() => {
          if (this.isPlaying) {
            this.millisecondsWatched += 1000
            secondsCounter += 1

            if (secondsCounter >= 30 || this.percentageWatched >= 100) {
              axios.post(`/api/v1/student/content/progress/${this.content.id}`, {
                seconds_duration: Math.trunc(this.secondsDuration),
                seconds_watched:
                  this.secondsWatched >= this.secondsDuration
                    ? Math.trunc(this.secondsDuration)
                    : Math.trunc(this.secondsWatched),
              })
              secondsCounter = 0
            }
          }
        }, 1000)
      },
    }
}